import React, { Suspense, useEffect, useState } from "react";
import { TradingListWrapper } from "./TradingListStyle";
import Typography from "../../components/Typography/Typography";
import { useGetCustomer, useGetTradesList } from "../../hooks/useCrm";
import Loading from "../../components/Loadings/LoadingTable";
import { separate } from "../../utils/separate";
import { InputField1 } from "../../components/InputField1/InputField1";
import Button from "../../components/Button/Button";
import { TransactionFilterModal } from "../../components/Dialog/TransactionFilterModal";
import { useRecoilValue } from "recoil";
import { crmFilteredTransaction } from "../../shared/crm-filtered-transactions";

import InvoiceItem from "../../components/InvoiceItem/InvoiceItem";
import { filterTradingList } from "../../shared/filterTradingList";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
const modalinitvalue = {
  transactionfilter: false,
};
export const TradingList = () => {
  const [orderType, setOrderType] = useState([
    "order_onlines",
    "order_offlines",
    "order_offlines_unsuccessfuls",
    "CurrentTradesorder_onlines",
  ]);
  const [marketerType, setMarketerType] = useState([
    "order_onlinesMarketer",
    "order_offlinesMarketer",
    "order_offlines_unsuccessfulsMarketer",
    "CurrentTradesorder_onlinesMarketer",
  ]);
  const [searchValue, setSearchValue] = useState("");
  const { data: customerresponsible } = useGetCustomer();
  const customerResponsible = customerresponsible?.data?.Colleague;
  const customerResponsibleOptions = customerResponsible?.map((res) => {
    return {
      value: res.IdUser,
      label: res.FirstName + " " + res.LastName,
    };
  });
  const [show, setShow] = useState(modalinitvalue);
  const {
    data: tradeslist,
    isLoading: tradingListLoading,
    hasNextPage,
    fetchNextPage,
  } = useGetTradesList();

  const tradeData = tradeslist?.pages[0]?.data;
  const filteredData = useRecoilValue(crmFilteredTransaction);
  const filteredTradeData = filteredData?.pages[0]?.data;
  const updateTradeMode = (mode) => {
    if (mode === "All") {
      setOrderType([
        "order_onlines",
        "order_offlines",
        "order_offlines_unsuccessfuls",
        "CurrentTradesorder_onlines",
      ]);
      setMarketerType([
        "order_onlinesMarketer",
        "order_offlinesMarketer",
        "order_offlines_unsuccessfulsMarketer",
        "CurrentTradesorder_onlinesMarketer",
      ]);
    } else if (mode === "Successful-Online") {
      setOrderType(["order_onlines"]);
      setMarketerType(["order_onlinesMarketer"]);
    } else if (mode === "Unsuccessful") {
      setOrderType(["order_offlines_unsuccessfuls"]);
      setMarketerType(["order_offlines_unsuccessfulsMarketer"]);
    } else if (mode === "In-Progress") {
      setOrderType(["CurrentTradesorder_onlines"]);
      setMarketerType(["CurrentTradesorder_onlinesMarketer"]);
    } else if (mode === "Successful-Offline") {
      setOrderType(["order_offlines"]);
      setMarketerType(["order_offlinesMarketer"]);
    }
  };
  useEffect(() => {
    let fetching = false;
    const onScroll = async (event) => {
      const { scrollHeight, scrollTop, clientHeight } =
        event.target.scrollingElement;
      if (!fetching && scrollHeight - scrollTop <= clientHeight * 2.5) {
        fetching = true;
        if (hasNextPage) await fetchNextPage();
        fetching = false;
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [fetchNextPage, hasNextPage]);
  const filterTrading = useRecoilValue(filterTradingList);
  const responsibleFiltered = customerResponsibleOptions?.filter((item) =>
    item.value === filterTrading?.IdMarketer
      ? item?.FirstName + " " + item?.LastName
      : ""
  );
  if (tradingListLoading) {
    return (
      <div className="d-flex justify-content-center">
        <Loading />
      </div>
    );
  }
  return (
    <TradingListWrapper>
      <BreadCrumb
        margin="mt-3"
        num1="واحد CRM"
        num2="گزارشگیری"
        num3="معاملات"
        href1="/dashboard/crm"
        href2="/dashboard/crm/reporting"
      />
      <div className="container-fluid">
        <div className="search-wrapper row">
          <div className="flex-wrap col-lg-12 col-md-12 col-sm-12 col-12 d-flex">
            <div className="input">
              <InputField1
                onChange={(e) => setSearchValue(e.target.value)}
                placeholder="جستجو در معاملات"
                label="جستجو"
              />
            </div>
            <Button
              bgColor="#dc3847"
              color="#fff"
              small="fit-content"
              className="filter-button"
              onclick={() => setShow({ ...show, transactionfilter: true })}
            >
              فیلتر معاملات
            </Button>
            <div className="flex-wrap d-flex">
              <Typography className="pt-3 mx-2 mt-lg-4" mdsize="12px">
                {filterTrading?.FactorTag
                  ? `برچسب: ${filterTrading?.FactorTag}`
                  : ""}
              </Typography>
              <Typography className="pt-3 mx-2 mt-lg-4" mdsize="12px">
                {filterTrading?.Start
                  ? `بازه ابتدائی: ${filterTrading?.Start}`
                  : ""}
              </Typography>
              <Typography className="pt-3 mx-2 mt-lg-4" mdsize="12px">
                {filterTrading?.End
                  ? `بازه انتهایی: ${filterTrading?.End}`
                  : ""}
              </Typography>
              <Typography className="pt-3 mx-2 mt-lg-4" mdsize="12px">
                {responsibleFiltered.length
                  ? " مسئول :" + responsibleFiltered[0]?.label
                  : ""}
              </Typography>
            </div>
          </div>
        </div>
        <div className="mt-3 filterButtons row justify-content-evenly">
          <div
            className="mb-3 col-lg-2 col-md-5 col-sm-5 col-12 button button-inprogress"
            onClick={() => updateTradeMode("In-Progress")}
          >
            <Typography size="14px">
              تعداد معاملات جاری :{" "}
              {!filteredTradeData && tradeData
                ? separate(tradeData?.NumberCurrentTradesorder_onlines)
                : filteredTradeData &&
                  tradeData &&
                  filteredTradeData?.NumberCurrentTradesorder_onlines
                ? separate(filteredTradeData?.NumberCurrentTradesorder_onlines)
                : "0"}
            </Typography>
            <Typography size="14px">
              کل مبلغ :{" "}
              {!filteredTradeData && tradeData
                ? separate(tradeData?.SumCurrentTradesorder_onlines)
                : filteredData &&
                  tradeData &&
                  filteredTradeData?.SumCurrentTradesorder_onlines
                ? separate(filteredTradeData?.SumCurrentTradesorder_onlines)
                : "0"}
            </Typography>
          </div>
          <div
            className="mb-3 col-lg-2 col-md-5 col-sm-5 col-12 button button-failed"
            onClick={() => updateTradeMode("Unsuccessful")}
          >
            <Typography size="14px">
              تعداد معاملات ناموفق :{" "}
              {!filteredTradeData && tradeData
                ? separate(tradeData?.Numberorder_offlines_unsuccessfuls)
                : filteredTradeData &&
                  tradeData &&
                  filteredTradeData?.Numberorder_offlines_unsuccessfuls
                ? separate(
                    filteredTradeData?.Numberorder_offlines_unsuccessfuls
                  )
                : "0"}
            </Typography>
            <Typography size="14px">
              کل مبلغ :{" "}
              {!filteredTradeData && tradeData
                ? separate(tradeData?.Sumorder_offlines_unsuccessfuls)
                : filteredTradeData &&
                  tradeData &&
                  filteredTradeData?.Sumorder_offlines_unsuccessfuls
                ? separate(filteredTradeData?.Sumorder_offlines_unsuccessfuls)
                : "0"}
            </Typography>
          </div>
          <div
            className="mb-3 col-lg-2 col-md-5 col-sm-5 col-12 button button-success-offline"
            onClick={() => updateTradeMode("Successful-Offline")}
          >
            <Typography size="14px">
              تعداد معاملات موفق آفلاین :{" "}
              {!filteredTradeData && tradeData
                ? separate(tradeData?.AllNumberorder_offlines)
                : filteredTradeData &&
                  tradeData &&
                  filteredTradeData?.AllNumberorder_offlines
                ? separate(filteredTradeData?.AllNumberorder_offlines)
                : "0"}
            </Typography>
            <Typography size="14px">
              کل مبلغ :{" "}
              {!filteredTradeData && tradeData
                ? separate(tradeData?.Sumorder_offlines)
                : filteredTradeData &&
                  tradeData &&
                  filteredTradeData?.Sumorder_offlines
                ? separate(filteredTradeData?.Sumorder_offlines)
                : "0"}
            </Typography>
          </div>
          <div
            className="mb-3 col-lg-2 col-md-5 col-sm-5 col-12 button button-success-online "
            onClick={() => updateTradeMode("Successful-Online")}
          >
            <Typography size="14px">
              تعداد معاملات موفق آنلاین :{" "}
              {!filteredTradeData && tradeData
                ? separate(tradeData?.Numberorder_onlines)
                : filteredTradeData && tradeData
                ? separate(filteredTradeData?.Numberorder_onlines)
                : "0"}
            </Typography>
            <Typography size="14px">
              کل مبلغ :{" "}
              {!filteredTradeData && tradeData
                ? separate(tradeData?.Sumorder_onlines)
                : filteredTradeData &&
                  tradeData &&
                  filteredTradeData?.Sumorder_onlines
                ? separate(filteredTradeData?.Sumorder_onlines)
                : "0"}
            </Typography>
          </div>
          <div
            className="mb-3 col-lg-2 col-md-5 col-sm-5 col-12 button button-all-orders"
            onClick={() => updateTradeMode("All")}
          >
            <Typography size="14px">
              تعداد کل معاملات :{" "}
              {!filteredTradeData && tradeData
                ? tradeData?.AllNumberorder_offlines +
                  tradeData?.Numberorder_onlines
                : filteredTradeData && tradeData
                ? filteredTradeData?.AllNumberorder_offlines +
                  filteredTradeData?.Numberorder_onlines
                : "0"}
            </Typography>
            <Typography size="14px">
              کل مبلغ :{" "}
              {!filteredTradeData && tradeData
                ? separate(
                    parseInt(tradeData?.Sumorder_offlines) +
                      parseInt(tradeData?.Sumorder_onlines)
                  )
                : filteredTradeData && tradeData
                ? separate(
                    parseInt(filteredTradeData?.Sumorder_offlines) +
                      parseInt(filteredTradeData?.Sumorder_onlines)
                  )
                : "0"}
            </Typography>
          </div>
        </div>
        <InvoiceItem
          data={tradeslist}
          marketerType={marketerType}
          orderType={orderType}
          searchValue={searchValue}
        />
      </div>
      <TransactionFilterModal
        show={show.transactionfilter}
        handleClose={() => setShow({ ...show, transactionfilter: false })}
        responsible={customerResponsibleOptions}
      />
    </TradingListWrapper>
  );
};
